export const LanguageMap = new Map([
  ['ru', { lang: 'ru' }],
  ['en', { lang: 'en' }],
  ['uzb-lath', { lang: 'uzLatn' }],
  ['uzb-cyrl', { lang: 'uz' }],
  ['tg', { lang: 'tg' }],
]);
